import type { FC } from "react";
import { Modal } from "./Modal";
import { useAllModals, useLayoutActions } from "../../../store";

/**
 * ModalManager component that renders all modals managed by the layout store
 * Should be placed once at the root level of your application
 */
export const ModalManager: FC = () => {
  const modals = useAllModals();
  const { closeModal } = useLayoutActions();

  return (
    <>
      {Object.values(modals).map((modal) => (
        <Modal
          key={modal.id}
          open={modal.isOpen}
          onOpenChange={(open) => {
            if (!open) {
              closeModal(modal.id);
            }
          }}
          size={modal.size}
        >
          {modal.content}
        </Modal>
      ))}
    </>
  );
};
